import Vue from 'vue'
import VueAB from 'vue-a2b'

Vue.use(VueAB)
